import { useCallback } from 'react';
import { WORLD_LANGUAGE_SUBJECTS_IDS } from 'chameleon-src/constants/subjects';
import { QUESTION_TYPES } from 'chameleon-src/constants/assignment';

const useQuizTitle = (subjectId, unitNumber, subunitTitle) => {
  const prefix = WORLD_LANGUAGE_SUBJECTS_IDS.includes(parseInt(subjectId, 10))
    ? `Unit ${unitNumber}: `
    : '';
  const title = `${prefix}${subunitTitle} Quiz`;

  const getTitleByType = useCallback((itemTypeOption = 'all') => {
    const suffix =
      itemTypeOption === 'all'
        ? ''
        : itemTypeOption === QUESTION_TYPES.mcq
          ? ' (MCQs)'
          : ' (FRQs)';

    return `${title}${suffix}`;
  }, []);

  return {
    getTitleByType,
  };
};

export default useQuizTitle;
